var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"money text-base",style:({"font-size":_vm.sized})},[_c('span',{staticClass:"text-sm",style:({"font-size":_vm.sized2})},[_vm._v("￥")]),_c('span',[_vm._v(_vm._s(_vm.count[0])+".")]),_c('span',{staticClass:"text-sm",style:({"font-size":_vm.sized2})},[_vm._v(_vm._s(_vm.count[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }